module.exports = __webpack_public_path__ + "img/01.6bff3025.png";